(() => {
  const header=document.querySelector('[data-bto-mega-menu]');
  if(!header)return;
  const navigation=header.querySelector('.bto-global-navigation');
  const search=header.querySelector('.bto-global-search');
  const groups=[...header.querySelectorAll('.bto-mega-group')];
  const desktop=matchMedia('(min-width:1001px)');
  function closeGroups(except){groups.forEach(group=>{if(group!==except)group.open=false;});}
  function closeAll(){closeGroups();search.open=false;navigation.open=desktop.matches;}
  groups.forEach(group=>group.addEventListener('toggle',()=>{if(group.open){closeGroups(group);search.open=false;}}));
  search.addEventListener('toggle',()=>{if(search.open){closeGroups();navigation.open=desktop.matches;search.querySelector('input').focus();}});
  navigation.addEventListener('toggle',()=>{if(navigation.open&&!desktop.matches)search.open=false;});
  document.addEventListener('click',event=>{if(!header.contains(event.target))closeAll();});
  header.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    const opened=event.target.closest('details[open]');
    if(opened){opened.open=false;opened.querySelector('summary').focus();event.preventDefault();}
  });
  header.addEventListener('click',event=>{if(event.target.closest('a[href]'))closeAll();});
  header.addEventListener('focusout',()=>setTimeout(()=>{if(!header.contains(document.activeElement))closeAll();},0));
  desktop.addEventListener('change',closeAll);
  navigation.open=desktop.matches;
  // Refresh from the confirmed Shopify cart after theme and quiz cart events.
  let cartRefreshTimer;
  function refreshCartCount(){
    clearTimeout(cartRefreshTimer);
    cartRefreshTimer=setTimeout(async()=>{
      try {
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{headers:{Accept:'application/json'}});
        if(response.ok)document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:await response.json()}}));
      }catch(_){}
    },150);
  }
  document.addEventListener('cart:refresh',refreshCartCount);
  // App cart drawers can complete form submissions without publishing theme events.
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement)||!form.action.includes('/cart/add'))return;
    setTimeout(refreshCartCount,1200);
    setTimeout(refreshCartCount,4000);
  },true);
  const connectCartEvents=()=>{if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,refreshCartCount);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',connectCartEvents,{once:true});else connectCartEvents();
  document.addEventListener('cart:updated',event=>{
    const count=event.detail?.cart?.item_count??event.detail?.item_count;
    if(!Number.isFinite(count))return;
    const badge=header.querySelector('[data-bto-menu-cart-count]');badge.textContent=count;badge.hidden=count===0;
    badge.closest('a').setAttribute('aria-label',count?`View cart, ${count} ${count===1?'item':'items'}`:'View cart');
  });
})();
